// extracted by mini-css-extract-plugin
export var anchor = "bm_ff";
export var anchors = "bm_fd";
export var document = "bm_fj";
export var documents = "bm_fh";
export var heading = "bm_G";
export var privacy = "bm_fg";
export var section = "bm_b";
export var tariff = "bm_fl";
export var tariffs = "bm_fk";